'use client';

import { __assign } from '../../_virtual/_tslib.js';

var rules = function (_a) {
    var types = _a.types, custom = _a.custom, t = _a.t;
    var fieldRules = types.map(function (type, _) {
        var _a;
        if (!type)
            return;
        switch (type) {
            case 'required':
                return __assign({ type: type }, { msg: t('Vui lòng nhập thông tin.') });
            case 'no-special-chars':
                return __assign({ type: type }, { msg: t('Vui lòng không nhập số hoặc kí tự đặc biệt.') });
            case 'no-special-chars-without-number':
                return __assign({ type: type }, { msg: t('Vui lòng không nhập kí tự đặc biệt.') });
            case 'no-special-chars-for-job-title':
                return __assign({ type: type }, { msg: t('Vui lòng không nhập kí tự đặc biệt.') });
            case 'no-number-email':
                return __assign({ type: type }, { msg: t('Vui lòng không nhập số điện thoại hoặc email') });
            case 'email':
                return __assign({ type: type }, { msg: t('This is not a valid email address') });
            case 'number':
                return __assign({ type: type }, { msg: t('Số điện thoại không hợp lệ') });
            case 'vn-phone-number': {
                return __assign({ type: type }, { msg: t('Số điện thoại của bạn không hợp lệ.') });
            }
            case 'international-phone-number': {
                return __assign({ type: type }, { msg: t('Số điện thoại của bạn không hợp lệ.') });
            }
            case 'custom':
                if (custom === null || custom === void 0 ? void 0 : custom.validator) {
                    return __assign({ type: type }, { msg: (_a = custom === null || custom === void 0 ? void 0 : custom.msg) !== null && _a !== void 0 ? _a : '', validator: custom === null || custom === void 0 ? void 0 : custom.validator });
                }
                return undefined;
            default:
                return undefined;
        }
    });
    return fieldRules && fieldRules.length > 0 ? fieldRules : undefined;
};

export { rules };
//# sourceMappingURL=index.js.map
